export default "__VITE_ASSET__DpY9weDN__"